/*
 *   Copyright (c) 2020 BuserNet Consulting LLC
 *   All rights reserved.
 */
import AppConst from '../../../constants/app.constant';
import ApiConstant from '../../../constants/api.constant';
import httpService from '../../../services/http.service';
import { processAllRadarSites } from './utils/processStormTrack/processAllRadarSites';
import { getServiceHostPreference } from '../../../services/utils/getServiceHostPreference';

const stormTrackDataService = () => {
  let allStorms;
  let stormTrackDataLoadedAt;
  let isGettingMeetarData = false;
  function resetStormTrackDataIfInValid() {
    const currentTime = window.performance.now();
    if ((currentTime - stormTrackDataLoadedAt) >= AppConst.stormTrackRequestAge) {
      allStorms = null;
      stormTrackDataLoadedAt = null;
    }
  }
  const getStormTrackDataRemote = async () => {
    if (!isGettingMeetarData) {
      isGettingMeetarData = true;
      const data = await httpService.http_get(
        `${getServiceHostPreference()}/${ApiConstant.stormTrackData}?bncachebuster=${Date.now()}`,
      );
      isGettingMeetarData = false;
      if (data) {
        allStorms = processAllRadarSites(data);
        stormTrackDataLoadedAt = window.performance.now();
      }
    }
  };
  const content = {};
  content.resetStormTrackService = () => {
    allStorms = null;
    stormTrackDataLoadedAt = null;
  };
  content.getStormTrackDataModel = () => {
    resetStormTrackDataIfInValid();
    return { allStorms };
  };
  content.getData = async () => {
    if (allStorms) {
      resetStormTrackDataIfInValid();
    }
    if (!allStorms) {
      await getStormTrackDataRemote();
    }
    return content.getStormTrackDataModel();
  };
  return content;
};
export default stormTrackDataService();
